import api from "./api";

interface MyActorToggleFavoriteProps {
  actorId: string;
}

interface MyActorToggleFavoriteParams {
  customize_actor_template_id: string;
}

// 收藏/取消收藏演员视频（演员弹窗 - My Actors）（定制化演员）
export const myActorToggleFavorite = async (actorId: MyActorToggleFavoriteProps["actorId"]) => {
  const params: MyActorToggleFavoriteParams = {
    customize_actor_template_id: actorId,
  };
  const res = await api.post<unknown>('/user-customize-actor-template/toggle-favorite', params);
  return res;
};
